import { Element } from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import { memo, useEffect, useState } from 'react';
import { IMatchDetail } from '@zmedia/bm-soccer-ui/interface';
import { Status } from '../status';
import { useDispatch, useSelector } from 'react-redux';
import { matchLiveSelector } from '@zmedia/bm-soccer-ui/selectors/match';
import { shouldUpdateLiveMatch } from '@zmedia/bm-soccer-ui/redux/actions/match';
import styles from './style.module.scss';
import { isLiveMatch } from '@zmedia/bm-soccer-ui/utils/soccer';
import { unixToDate } from '@zmedia/bm-soccer-ui/utils/date';
import { MATCH_STATUS } from '@zmedia/bm-soccer-ui/constants';

interface IProps {
    item: IMatchDetail;
    isDetailPage?: boolean;
    isLive?: boolean;
}
export function Score({ item, isDetailPage = false }: IProps) {
    const { startTime = 0, status } = item;

    if (isLiveMatch(status)) {
        return <LiveScore item={item} isDetailPage={isDetailPage} />;
    }

    if (status.id === MATCH_STATUS.NOT_STARTED) {
        return (
            <Element className={cn(styles['score'], styles['not-started'])}>
                {unixToDate(startTime)}
            </Element>
        );
    }

    if (status.id === MATCH_STATUS.POSTPONED) {
        return (
            <Element className={cn(styles['score'], styles['postponed'])}>
                {unixToDate(startTime)}
            </Element>
        );
    }

    return <MatchScore item={item} isDetailPage={isDetailPage} />;
}

function LiveScore({ item, isDetailPage }: IProps) {
    const [state, setItem] = useState<IMatchDetail>(item);
    const items = useSelector(matchLiveSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(shouldUpdateLiveMatch(true));
    }, []);

    useEffect(() => {
        const liveData = items.filter((data) => {
            return data.id === item.id;
        })[0];

        if (liveData) {
            setItem(liveData);
        } else {
            setItem(
                Object.assign({}, item, {
                    status: {
                        id: 3,
                        name: MATCH_STATUS.FT,
                    },
                })
            );
        }
    }, [items]);

    return (
        <MatchScore item={state} isDetailPage={isDetailPage} isLive={true} />
    );
}

function MatchScore({ item, isDetailPage = false, isLive = false }: IProps) {
    const { home, away, status, hasPenShootout, minuteLabel, penaltyShootout } =
        item;

    const renderPenalty = () => {
        if (isDetailPage) {
            return (
                <Element className={styles['full-scores']}>
                    Pen: {penaltyShootout?.hScorePen}-
                    {penaltyShootout?.aScorePen}
                </Element>
            );
        }
        return (
            <>
                <Element className={styles['home-pen-score']}>
                    ({home.scorePen})
                </Element>
                <Element className={styles['away-pen-score']}>
                    ({away.scorePen})
                </Element>
            </>
        );
    };

    return (
        <>
            <Status status={status} minute={minuteLabel} />
            <Element
                className={cn(styles['score'], { [styles['is-live']]: isLive })}
            >
                <Element renderAs='span'>{home.score}</Element>
                <Element renderAs='span'>&nbsp;{` - `}&nbsp;</Element>
                <Element renderAs='span'>{away.score}</Element>
                {hasPenShootout && <>{renderPenalty()}</>}
            </Element>
        </>
    );
}
export default memo(Score);
